import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function AmiantePage() {
  return <ServicePage data={servicesData.amiante} />;
}
